<p-steps [model]="stepsItem"
         [(activeIndex)]="activeStepIndex"
         [readonly]="false"
         class="p-steps-component"
>
</p-steps>
